'use client';

import { ChakraProvider, createSystem, defaultConfig, defineConfig, defineRecipe } from '@chakra-ui/react';

const customConfig = defineConfig({
   globalCss: {
    '*': {
      outline: 'none'
    },
    body: {
      color: 'gray.600',
      fontSize: '16px',
      fontWeight: '300',
      lineHeight: '1.4em'
    },
    p: {
      pb: '10px',
    },
    a: {
      transition: 'color 0.3s ease',
      textDecoration: 'none !important'
    }
  },
  theme: {
    config: {
      initialColorMode: 'light',
      useSystemColorMode: false,
    },
    keyframes: {
      shakeX: {
        '0%, 90%': { transform: 'translate3d(-1px, 0, 0)' },
        '20%, 80%': { transform: 'translate3d(1px, 0, 0)' },
        '30%, 50%, 70%': { transform: 'translate3d(-2px, 0, 0)' },
        '40%, 60%': { transform: 'translate3d(2px, 0, 0)' },
      },
    },
    tokens: {
      colors: {
        blue: {
          50:  '#e0f7ff',
          100: '#b3ecff',
          200: '#80e0ff',
          300: '#4dd4ff',
          400: '#1ac8ff',
          500: '#00bdff', // base
          600: '#00a0d9',
          700: '#0083b3',
          800: '#00668d',
          900: '#004966'
        },
        red: {
          50:  '#feefef',
          100: '#fdcdcd',
          200: '#f99999',
          300: '#f66666',
          400: '#f23333',
          500: '#ef4444', // base
          600: '#c73737',
          700: '#9f2b2b',
          800: '#771f1f',
          900: '#501414'
        },
        black: {
          500: '#000'
        },
        gray: {
          50:  '#f4f5f5',
          100: '#d7dadb',
          200: '#babfc0',
          300: '#9da4a6',
          400: '#80888a',
          500: '#6c7375', // base
          600: '#585d5f',
          700: '#444748',
          800: '#303334',
          900: '#1c1e1f'
        }
      },
    }
  },
})

 const system = createSystem(defaultConfig, customConfig)

export function Provider({ children }) {
  return <ChakraProvider value={system}>{children}</ChakraProvider>
}
